import React from "react";
import "./ForgotPassword.scss";

import { Link } from "react-router-dom";
import { withFirebase } from "components/Firebase";
import * as ROUTES from "constants/routes";

import Input from "components/Input";
import Button from "components/Button";

const INITIAL_STATE = {
  form: {
    email: ""
  },
  error: null
};

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  handleInputChange = e => {
    const { id, value } = e.target;
    const { form } = this.state;
    form[id] = value;
    this.setState({ form });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { email } = this.state.form;
    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        this.setState({ error });
      });
  };
  render() {
    const { error, form } = this.state;
    return (
      <div className="ForgotPassword">
        <div className="content">
          <h3>Forgot password?</h3>
          <form onSubmit={this.handleSubmit} action="">
            <Input
              onChange={this.handleInputChange}
              autoFocus
              name="email"
              value={form.email}
              label="Email"
              type="email"
              placeholder="Enter your email address"
            />
            {error && <p>{error}</p>}
            <Button type="primary">Reset my password</Button>
          </form>
        </div>
        <div className="footer">
          <span>
            <Link to={ROUTES.SIGN_IN}>Back to Sign In</Link>
          </span>
        </div>
      </div>
    );
  }
}

export default withFirebase(ForgotPassword);
